import { HydrateOption } from '@core/enums';
import { Grid } from '@helpers/grid';
import withWidget from '@hoc/withWidget';
import Heading from '@stories/Components/Global/Typography/Heading';
import Breadcrumbs from '@stories/Widgets/Meta/Breadcrumbs/Breadcrumbs.widget';
import React from 'react';
import { InnerBannerStyles as S } from './InnerBanner.styles';
import { ThemeWrapper } from '@helpers/theme';
const InnerBanner = (props) => {
    return (React.createElement(ThemeWrapper, { "data-theme": props.theme },
        React.createElement(S.Wrapper, null,
            React.createElement(Breadcrumbs, { items: props.breadcrumbItems }),
            React.createElement(Grid.Default, null,
                React.createElement(Heading, { semantic: "h1", visual: "h3" }, props.title)))));
};
export default withWidget(InnerBanner, 'InnerBanner', { hydrate: HydrateOption.Always });
